export const hasOnboardingContent = (content: string | undefined): boolean => {
  if (!content) return false

  // If using Quill or HTML content
  const textContent = content.replace(/<[^>]*>/g, '').trim()

  return textContent.length > 0
}
